/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import { Badge, Button, Form } from 'react-bootstrap';
import CommonToggle from "../../Common/CommonToggle";
import { Link, useNavigate, useLocation, useParams  } from "react-router-dom";
import { REGION_MASTER_URL } from "../../Shared/constant";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import CheckValid from "../../Common/CheckValid";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";

const AddRegionMaster = () => {
    const Dispatch = useDispatch();
    const Navigate = useNavigate();
    const LocationRoute = useLocation()?.pathname?.split("/")[1];
    const { websocket } = useContext(WebSocketContext);
    const [ UploadFileLoader, setUploadFileLoader ] = useState(false);
    const [ ApplicationState, setApplicationState ] = useState({
        RegionName: "",
        Status: true
    });
    const { roomId } = useParams();
    const { accessToken, ClearFormSet, regionMasterList, device_id } = useSelector((state) => state.adminReducers);
    const CurrentData_ = regionMasterList?.list?.filter((elm) => elm?.id === roomId)[0];

    // error state
    const [ errorRegionName, seterrorRegionName ] = useState("");

    useEffect(() => {
        if(LocationRoute === "edit-region-master") {
            setApplicationState({
                ...ApplicationState,
                RegionName: CurrentData_?.region_name,
                Status: CurrentData_?.is_active
            });
        };
    }, [ CurrentData_ ])

    // create and edit brand
    const CreateBrand = () => {
        if(ApplicationState?.RegionName.trim() !== "") {
            if(LocationRoute === "edit-region-master") {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "region_edit",
                    "request" : { 
                        "region_id" : CurrentData_?.id,
                        "region_name" : ApplicationState?.RegionName.trim(), 
                        "is_active" : ApplicationState?.Status
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            } else {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "region_add",
                    "request" : { 
                        "region_name" : ApplicationState?.RegionName.trim(), 
                        "is_active" : ApplicationState?.Status
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            }
        } else {
            CheckValid(ApplicationState?.RegionName.trim(), {type: 'RegionName', error: seterrorRegionName});
        };
    };

    useEffect(() => {
        if(ClearFormSet?.action === 200) {
            Navigate(REGION_MASTER_URL);
        };
    }, [ ClearFormSet ]);


    return(<section className="createApplcation_wrapper">
        <div className="MainHeader">
            <Link to={REGION_MASTER_URL} className="btn btn-link backbtn"><i className="bi bi-arrow-left-short"></i> Back</Link>
        </div>
        <div className="tabsWrappers">
            <div className="formloginset">
                <div className="row">
                    <div className="col-md-6">
                        <Form.Group className="mb-3" >
                            <Form.Label>Region<span className="mendatory_star">*</span></Form.Label>
                            <Form.Control 
                                type="text" 
                                value={ApplicationState?.RegionName} 
                                onChange={(e) => setApplicationState({...ApplicationState, RegionName: e.target.value})}
                                onKeyUp={(e) => CheckValid(e.target.value, {type: 'RegionName', error: seterrorRegionName})}
                                onKeyDown={EmptySpaceFieldValid}
                                placeholder="Enter Region Name" 
                                disabled={UploadFileLoader}
                            />
                            {errorRegionName !== "" &&<span className="error_medotory">{errorRegionName}</span>}
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <CommonToggle 
                            isBadgeAllow={true}
                            badgeTitle={"active_inactive"}
                            valueToggle={ApplicationState?.Status}
                            setValueToggle={() => setApplicationState({...ApplicationState, Status: !ApplicationState?.Status})}
                            name={"Status"}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Button className="formbtn widthfullbtn" onClick={() => CreateBrand()} variant="primary" >
                            {LocationRoute === "edit-region-master" ? "Update" : "Add"}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </section>)
}

export default AddRegionMaster;